import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.16666 10.8333H4.16666V9.16666H9.16666V4.16666H10.8333V9.16666H15.8333V10.8333H10.8333V15.8333H9.16666V10.8333Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
